import React from 'react';
import { fontFamily, colour, ActionButton, Input } from './GlobalStyles';
import { useSelector, useDispatch } from 'react-redux';
import { phoneAction } from './actions';
import './MobileBookPage.css';

const PhoneMobile = React.forwardRef((props, ref) => {

    const currentPhone = useSelector(state => state.phoneAction);
    const dispatch = useDispatch();

    const styles = {
        headerText: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontWeight: 'normal',
            fontSize: '1.375em',
            textAlign: 'center'
        },
        back: {
            fontFamily: fontFamily,
            color: colour.dark,
            fontSize: '0.875em',
            fontWeight: 'normal',
            textAlign: 'center',
            cursor: 'pointer'
        }
    }

    return (
        <div className="mobileBookPageOuterContainer">
            <h1 style={styles.headerText}>
                Inserisci il tuo numero di telefono
            </h1>
            <div>
                <Input
                    value={currentPhone}
                    id="outlined"
                    label="Telefono"
                    inputProps={{
                        autoCapitalize: 'none',
                    }}
                    variant="outlined"
                    onChange={(text) => dispatch(phoneAction(text.target.value))}
                />
                <div style={{ height: '2vh' }} />
                <ActionButton
                    ref={ref} {...props}
                    disabled={
                                currentPhone === "" ?
                                true
                                :
                                false
                            }
                >
                    Continua
                </ActionButton>
                <div style={{ height: '2vh' }} />
                <p
                    onClick={() => props.onBack()} 
                    style={styles.back}
                >
                    Indietro
                </p>
            </div>
        </div>
    )
})

export default PhoneMobile;